import React from "react";
import shaneSubmark from "../../images/logos/SHANE_SUBMARK-08.png";
import { YStack } from "tamagui";
import { Button, primary1, white } from "@shane-collective/design-system";
// import { useAppState } from "../../core/appState/UseAppState";
import { writeToLog } from "../../const";
import { useAppState } from "../../core/appState/UseAppStateZustand";

interface MapContainerProps {
  isSmallScreen: boolean;
  mapContainer: React.MutableRefObject<HTMLDivElement | null>;
}

const MapContainer: React.FC<MapContainerProps> = ({
  isSmallScreen,
  mapContainer,
}) => {
  const { hideMap } = useAppState();
  const {
    setSearchSet,
    setSearchResults,
    setIsLocationDialogOpen,
    setSelectedFeature,
    setIsSearchDialogOpen,
    setIsResultsDialogOpen,
    setFakeSearchInputValue,
    setHideMap,
  } = useAppState.getState();

  const onSubmarkPress = () => {
    writeToLog("[MapContainer] onsubmarkpress");
    setSearchResults([]);
    setSelectedFeature(null);
    setHideMap(false);
    setFakeSearchInputValue("");

    setSearchSet({ clearAll: true });
    if (!isSmallScreen) {
      setIsLocationDialogOpen(false);
      setIsSearchDialogOpen(true);
      setIsResultsDialogOpen(false);
    }
  };

  return (
    <>
      {/* //$ set up map container */}
      <div
        style={{ zIndex: 103, visibility: hideMap ? "hidden" : "visible" }}
        ref={mapContainer}
        className="map-container"
      />
      {hideMap && (
        <YStack
          fullscreen
          display="flex"
          justifyContent="center"
          alignItems="center"
          background={
            "linear-gradient(135deg, " + primary1 + ", " + white + ")"
          }
          rowGap={10}
        >
          <img src={shaneSubmark} alt="Shane submark" />
          <Button
            type="primary"
            labelColor={white}
            label="Back to map"
            onPress={onSubmarkPress}
          ></Button>
        </YStack>
      )}
    </>
  );
};

export default MapContainer;
